module.exports = __webpack_public_path__ + "static/media/Post to Next Year Blue.92145318.svg";